/**
 * Created by Alex Aguilar on 5/10/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {

        $stateProvider
            .state('itineraryFlight', {
                parent: 'app',
                url: '/itineraryFlight/:id',
                params: {
                    name: "",
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/flightControl/itinerary/itineraryFlight/itineraryFlights.html',
                        controller: 'itineraryFlightsCtrl',
                        controllerAs: 'vm',
                        resolve:{
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['itineraryFlight']);
                            }],
                            itineraryFlights: ['itineraryFlightService','$stateParams', function(itineraryFlightService,$stateParams){
                                return itineraryFlightService.getRouteItinerariesPageByItinerary($stateParams.id,$stateParams.page,$stateParams.size);
                            }]
                        }
                    }
                }
            })
            .state('itineraryFlightNew', {
                parent: 'app',
                url: '/itineraryFlight/:id/new',
                params: {
                    name: ""
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/flightControl/itinerary/itineraryFlight/itineraryFlightNew.html',
                        controller: 'newItineraryFlightCtrl',
                        controllerAs: 'vm',
                        resolve:{
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['itineraryFlight']);
                            }]
                        }
                    }
                }
            })
            .state('itineraryFlightEdit', {
                parent: 'app',
                url: '/itineraryFlight/:itineraryId/edit/:itineraryFlightId',
                params: {
                    name: ""
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/flightControl/itinerary/itineraryFlight/itineraryFlightEdit.html',
                        controller: 'editItineraryFlightCtrl',
                        controllerAs: 'vm',
                        resolve:{
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['itineraryFlight']);
                            }],
                            routeItinerary: ['itineraryFlightService','$stateParams','linkService',
                                function(itineraryFlightService,$stateParams,linkService){
                                return itineraryFlightService.getRouteItinerary($stateParams.itineraryFlightId)
                                    .then(function(res){
                                        return res;
                                    }, function(){
                                        linkService.reloadRoute('itineraryFlight', {id : vm.itineraryId});
                                    });
                            }]
                        }
                    }
                }
            })
            .state('itineraryFlightDelete', {
                parent: 'itineraryFlight',
                url: '/itineraryFlight/:routeItineraryId/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/flightControl/itinerary/itineraryFlight/deleteItineraryFlight.html',
                        controller: 'deleteItineraryFlightCtrl',
                        controllerAs: 'vm',
                        size: 'md',
                    }).result.then(function() {
                        $state.go('itineraryFlight', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
    }
})();
